import React, { useState } from "react";
import "./dashboard.css";
import ArticleIcon from "@mui/icons-material/Article";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import Popover from "@mui/material/Popover";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let iconColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    iconColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    iconColor = "var(--maincolor-cmc)";
    break;
  default:
    iconColor = "var(--maincolor)";
    break;
}

const DocumentCard = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="row document__card mb-3 d-flex align-items-center">
      <div className="col-md-1 col-1 p-0 document__icon d-flex align-items-center">
        <ArticleIcon
          sx={{
            fontSize: 15,
            color: "#7779CF",
          }}
        />
      </div>
      <div className="col-md-11 col-11 pl-5">
        <h3 className="document__title m-0">
          {/* {props.annonucements?.annoucement_title} */}
          Document Title
        </h3>
        <span
          className="stu-variant-class label label-lg label-light-success label-inline document__breadcrumb"
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          Institute › Faculties › Faculty of Management ›
        </span>
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: "none",
            padding: "8px 16px",
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <div style={{ padding: "8px 16px" }}>
            Institute › Faculties › Faculty of Management ›
          </div>
        </Popover>
        <div className="d-flex justify-content-end pt-1 document__content">
          <p>04-04-2024 2:08 PM</p>
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;